import { render, staticRenderFns } from "./update-pr-modal.vue?vue&type=template&id=7e946c92&"
import script from "./update-pr-modal.vue?vue&type=script&lang=js&"
export * from "./update-pr-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports